// Сводка варианта в шапке: даты, маршрут по аэропортам, переезды, ночёвки.
// Иконки те же, что на карточках сегментов (KindIcon), чтобы значок в сводке
// и значок на таймлайне читались как одно и то же.
import { KindIcon } from '../library';
import { useT } from '../../i18n';
import type { VariantSummary } from './variantSummary';
import styles from './VariantSummaryChips.module.css';

export interface VariantSummaryChipsProps {
  summary: VariantSummary;
}

export function VariantSummaryChips({ summary }: VariantSummaryChipsProps) {
  const t = useT();
  const empty = summary.flights === 0 && summary.rides === 0 && summary.nights === 0;
  if (empty) return null;

  return (
    <div className={styles.summary}>
      {summary.dates && <span className={`${styles.chip} mono`}>{summary.dates}</span>}

      {summary.items.map((item, i) => {
        if (item.kind === 'route') {
          return (
            <span key={i} className={`${styles.chip} ${styles.route} iata`}>
              {item.airports.join(' → ')}
            </span>
          );
        }

        if (item.kind === 'rides') {
          const text = t('summary.rides', { count: item.count });
          return (
            <span key={i} className={styles.chip} role="img" aria-label={text} title={text}>
              <KindIcon kind="taxi" size={13} />
              {item.count > 1 && <span className="mono">×{item.count}</span>}
            </span>
          );
        }

        const text = t('summary.nights', { count: item.count });
        return (
          <span key={i} className={styles.chip} role="img" aria-label={text} title={text}>
            <KindIcon kind="lodging" size={13} />
            <span className="mono">×{item.count}</span>
          </span>
        );
      })}
    </div>
  );
}
